'use strict';
(function($){
	/*
	 * Vetology.OneClickReferral widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.OneClickReferral',
		{
			"options": {},
			/*
			 * Vetology.OneClickReferral._init
			 *
			 * @description	Initializes the Vetology Platform
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._initDOMEvents();
				setInterval(
					function(){
						o._initObject();
					}, 100
				);
			},
			/*
			 * Vetology.OneClickReferral._initDOMEvents
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_initDOMEvents: function(){
				var o = this;
				o.initDomEvents1();
				o.initDomEvents2();
				o.initDomEvents3();
			},

			initDomEvents1: function () {
				const o = this;
				$("body").on("change", ".check_all_down", function (e) {
					var el = $(this);
					var tr = el.closest('tr');
					var name = "[name=\"" + el.data("target") + "\"]";
					var check_all = el.data("mode") == 1;
					var set = el.data("type");
					var config = {
						"sh": tr.data('specialty'),
						"clinic": 0,
						"all": 1,
						"set": set,
						"to": check_all ? 1 : 0
					};
					o._updateClinicNetwork(config, function () {
						var cells;
						cells = o.options.config.vetologyDataTable_distro.cells();
						var nodes = cells.nodes();
						$.each(nodes, function (i, node) {
							node = $(node);
							node.find(name).prop("checked", check_all);
						});
						cells = o.options.config.vetologyDataTable_notifications.cells();
						nodes = cells.nodes();
						$.each(nodes, function (i, node) {
							node = $(node);
							node.find(name).prop("checked", check_all);
						});
						cells = o.options.config.vetologyDataTable_distro_2.cells();
						nodes = cells.nodes();
						$.each(nodes, function (i, node) {
							node = $(node);
							node.find(name).prop("checked", check_all);
						});
					});
				});
				$("body").on("click", ".timeZoneSetter", function (e) {
					e.preventDefault();
					var el = $(this);
					var config = el.closest("td").data("config");
					var html = o._getTimeSelectorHTML(config);
					el.closest('td').html(html);
				});
				$("body").on("click", ".timeZoneSetterAll", function (e) {
					e.preventDefault();
					var el = $(this);
					var config = el.closest("th").data("config");
					var html = o._getTimeSelectorHTML(config, true);
					el.closest('th').html(html);
				});
				$("body").on("click", ".saveDateTimeDelay", function (e) {
					var el = $(this);
					var tr = el.closest('tr');
					var type_cell = el.closest("td").length > 0 ? "td" : "th";
					var td = el.closest(type_cell);
					var config = td.data('config');
					config.auto_distro_type = td.find(".auto_distro_type").val();
					if (config.auto_distro_type == 0) {
						config.auto_distro_delay = td.find(".auto_distro_delay").val();
						config.auto_distro_delay_type = td.find(".auto_distro_delay_type").val();
					} else if (config.auto_distro_type == 1) {
						config.auto_distro_time = td.find(".auto_distro_hour").val() + ":" + td.find(".auto_distro_minute").val();
						config.auto_distro_time_zone = td.find(".time_zone_selector").val();
					} else {
						alert("The options you have selected are invalid");
					}
					config.sh = tr.data('specialty');
					config.clinic = tr.data('clinic');
					config.all = type_cell == "th" ? 1 : 0;
					config.set = 9;
					o._updateClinicNetwork(config);
				});
				$("body").on("click", ".table_ocr_clinic_list tbody input[type=\"checkbox\"]", function (e) {
					var el = $(this);
					var tr = el.closest('tr');
					var set = el.data("type");
					var config = {
						"sh": tr.data('specialty'),
						"clinic": tr.data('clinic'),
						"all": 0,
						"set": set,
						"to": el.is(":checked") ? 1 : 0
					};
					o._updateClinicNetwork(config);
				});
				$("body").on("change", ".auto_distro_type", function (e) {
					var el = $(this);
					var type = parseInt(el.val(), 10);
					var cell_type = el.closest("td").length > 0 ? "td" : "th";
					var config = el.closest(cell_type).data("config");
					config.auto_distro_type = type;
					var html = o._getTimeSelectorHTML(config);
					el.closest(cell_type).html(html);
				});
				$('body').on('change', '.clinicOwnSelection', function () {
					var el = $(this);
					if (el.val() != '') {
						location.replace('/ocr-network?clinic=' + el.val());
					}
				});
			},

			initDomEvents2: function () {
				const o = this;
				$('body').on('click', '.change_status_keyword', function (e) {
					e.preventDefault();
					var el = $(this);
					o._setStatusKeyword(el);
				});
				$("body").on("change", ".auto_distro_delay_type", function (e) {
					var el = $(this);
					var type = parseInt(el.val(), 10);
					var sel = el.closest("td").find(".auto_distro_delay");
					switch (type) {
						case 2:
							var timer = 31;
							break;
						case 1:
							var timer = 24;
							break;
						default:
							var timer = 60;
							break;
					}
					var html = "";
					for (var i = 0; i < timer; i++) {
						html += "<option value=\"" + i + "\">" + i + "</option>";
					}
					sel.html(html);
				});
				$('body').on('click', ".getTrend", function (e) {
					o._getAnalytics($(this));
				});
				$('body').on('click', '.requestDataPull', function (e) {
					e.preventDefault();
					var el = $(this);
					var icon = $("[data-gpid=\"" + el.data('id') + "\"]");
					var config = {
						"sh": el.data('join'),
						"clinic": el.data('id'),
						"all": 0,
						"set": 0,
						"to": 1
					};
					window.enabled_clinics[el.data('id')] = true;
					o._updateClinicNetwork(config, function () {
						if (icon.hasClass('with_sikka')) {
							icon.addClass('sikka_paid');
						} else {
							icon.addClass('with_sikka').addClass('sikka_pending').append("<i class=\"vetology-stack\"></i>");
						}
						el.replaceWith("<span class=\"label label-success\">OCR data enabled for this clinic</span>");
					});
				});
				$('body').on('click', '.joinNetwork2', function (e) {
					e.preventDefault();
					var pms = $(".active_pms");
					var el = $(this);
					if (pms.length > 0) {
						return o._completeNetyworkRequest(pms, el);
					}
					var type = el.data('type');
					if (typeof type === "undefined") {
						type = 0;
					}
					var id = el.data('id');
					var clinicName = el.data('clinicname');
					var caseBlock = el.closest('.box-case');
					var clinic = caseBlock.parent().data('clinic');
					if (typeof clinic === 'undefined') {
						clinic = el.data('join');
					}
					var alertTitle = type == 0 ? 'Please enter a message for the Referral Center' : 'Please enter a message for ' + clinicName;
					var alertMessage = type == 0 ? 'A clinic is asking you to accept them in your OCR network' : 'Please join ' + el.data('shname') + '\'s referral network';
					var dataPulls = el.data("dataPulls");
					var data = {
						id: id,
						type: type,
						clinic: clinic,
						dataPulls: dataPulls
					};
					o._makeJoinNetRequest(id, alertMessage, alertTitle, data, el);
				});
				$("body").on("click", ".joinNetworkSpecialtyHospital", function (e) {
					e.preventDefault();
					var el = $(this);

					var type = el.data('type');
					if (typeof type === "undefined") {
						type = 0;
					}
					var id = el.data('id');
					var clinicName = el.data('clinicname');
					var caseBlock = el.closest('.box-case');
					var clinic = el.data('join');
					var alertTitle = typeof clinicName === "undefined" ? 'Please enter a message for the Referral Center' : 'Please enter a message for ' + clinicName;
					var alertMessage = type == 0 ? 'Please join ' + el.data('requestingname') + '\'s referral network' : 'A specialty hospital is asking you to accept them in your OCR network';
					var dataPulls = el.data("dataPulls");
					var data = {
						id: id,
						type: type,
						clinic: clinic,
						dataPulls: dataPulls,
					};
					o._makeJoinOcrSH(id, alertMessage, alertTitle, data, el);
				});
				$("body").on("click", ".auth_transfer", function (e) {
					e.preventDefault();
					var el = $(this);
					var token = el.data('token');
					var transfer = el.data('accept') == 1;
					o._auhtorizePatientTransfer(token, transfer);
				});

				$('body').on('click', '.acceptJoinNetwork', function (e) {
					e.preventDefault();
					var el = $(this);
					var id = el.data('id');
					$("body").Vetology("doRequest",
						'GET',
						{
							id: id
						},
						'/acceptRequest',
						function (data) {
							if (data.success) {
								$('body').Vetology('vetologyShowDialog', 'Success:', 'The request has been successfully accepted.', 'success');
								window.location.reload(false);
							} else {
								$('body').Vetology('vetologyShowDialog', 'Attention:', data.message, 'error');
							}
						},
						'JSON'
					);
				});
				$('body').on('click', '.denyJoinNetwork', function (e) {
					e.preventDefault();
					var el = $(this);
					var id = el.data('id');
					$("body").Vetology("doRequest",
						'GET',
						{
							id: id
						},
						'/denyRequest',
						function (data) {
							if (data.success) {
								el.html('Request denied').removeClass('denyJoinNetwork');
								$('body').Vetology('vetologyShowDialog', 'Success:', 'The request has been successfully denied.', 'success');
								window.location.reload(false);
							} else {
								$('body').Vetology('vetologyShowDialog', 'Attention:', data.message, 'error');
							}
						},
						'JSON'
					);
				});

			},

			initDomEvents3: function () {
				const o = this;
				var clinicSearchTimeout;
				$("body").on("keyup", ".caseDistroClinicSearch", function (e) {
					clearTimeout(clinicSearchTimeout);
					var el = $(this);
					var span = "<span class=\"searching vetology-loop spin2\"></span>";
					var p = el.closest(".searchFieldWrap");
					p.find(".searching").remove();
					var clinicSelector = p.find(".clinicSelector");
					clinicSelector.html("");
					p.addClass("searching").append(span);
					var clinicName = el.val();
					clinicSelector.data("placeholder", "Searching for clinics matching the name \'" + clinicName + "\"").select2();

					clinicSearchTimeout = setTimeout(
						function () {
							$.getJSON("/worklist/specialty-hospital/one-click-referrals-reviewed/distribute?clinic=" + clinicName, function (clinics) {
								p.removeClass("searching");
								p.find(".searching").remove();
								console.log(clinics)
								if (clinics.length > 0) {
									clinicSelector.append("<option selected=\"selected\" disabled=\"disabled\">Select the clinic that you like to distribute the case to from below</option>");
									$.each(clinics.records, function (id, clinic) {
										var o = "<option></option>";
										o = $(o);
										o.val(id);
										o.html(clinic);
										clinicSelector.append(o);
									});
									clinicSelector.data("placeholder", "Select the clinic that you like to distribute the case to").select2();
								} else {
									clinicSelector.data("placeholder", "No clinics found with the search criteria").select2();
								}
								clinicSelector.select2({ width: '100%' });
							});
						},
						500
					);
				});
				$("body").on("change", ".clinicSelector", function (e) {
					/*First find whether the clinic has already been selected*/
					var el = $(this);
					var clinic = el.find("option:selected");
					var existing = $(".distribution_table").find("tr.clinic_" + clinic.val());
					if (existing.length > 0) {
						return;
					}
					var tr = $("<tr></tr>");
					tr.data("clinic", clinic.val());
					tr.attr("class", "warning clinic_" + clinic.val());
					tr.append("<td>" + clinic.html() + "</td>");
					tr.append("<td><input value=\"1\" name=\"email_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"fax_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"share_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"docs_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"images_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"prescriptions_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"lab_panels_distro\" type=\"checkbox\"></td>");
					tr.append("<td><input value=\"1\" name=\"appointments_distro\" type=\"checkbox\"></td>");
					tr.append("<td style=\"min-width: 200px\"><input value=\"\" name=\"summary_keyword\" type=\"text\" class=\"form-control\" placeholder=\"Summary on keyword\"></td>");
					tr.append("<td><a href=\"#\" class=\"save_distro fa vetology-save-as\"></a></td>");
					tr.append("<td><a href=\"#\" class=\"remove_from_distro vetology-delete\"></a></td>");
					$(".distribution_table").append(tr);
					$.ajax({
						"dataType": "JSON",
						"method": "POST",
						"url": "/worklist/specialty-hospital/one-click-referrals-reviewed/distribute",
						"data": {
							"clinic": clinic.val(),
							"action": "setDistro",
							"case": $("#ocrcId").val()
						},
						"success": function (data) {
							tr.removeClass("warning");
						}
					});
				});
				$("body").on("click", ".distribution_table .save_distro", function (e) {
					e.preventDefault();
					var el = $(this);
					el.html("Saving Changes");
					var tr = el.closest('tr');
					var clinic = tr.data("clinic");
					tr.addClass("warning");
					var data = {
						"clinic": clinic,
						"email_distro": tr.find("[name=\"email_distro\"]").is(":checked") ? 1 : 0,
						"share_distro": tr.find("[name=\"share_distro\"]").is(":checked") ? 1 : 0,
						"fax_distro": tr.find("[name=\"fax_distro\"]").is(":checked") ? 1 : 0,
						"docs_distro": tr.find("[name=\"docs_distro\"]").is(":checked") ? 1 : 0,
						"images_distro": tr.find("[name=\"images_distro\"]").is(":checked") ? 1 : 0,
						"prescriptions_distro": tr.find("[name=\"prescriptions_distro\"]").is(":checked") ? 1 : 0,
						"lab_panels_distro": tr.find("[name=\"lab_panels_distro\"]").is(":checked") ? 1 : 0,
						"appointments_distro": tr.find("[name=\"appointments_distro\"]").is(":checked") ? 1 : 0,
						"summary_keyword": tr.find("[name=\"summary_keyword\"]").val(),
						"action": "updateDistro",
						"case": $("#ocrcId").val()
					};
					$.ajax({
						"dataType": "JSON",
						"method": "POST",
						"url": "/worklist/specialty-hospital/one-click-referrals-reviewed/distribute",
						"data": data,
						"success": function (data) {
							tr.removeClass("warning");
							el.html("Done");
							setTimeout(
								function () {
									el.html("");
								},
								1500
							)
						}
					});
				});
				$("body").on("click", ".remove_from_distro", function (e) {
					e.preventDefault();
					var el = $(this);
					var tr = el.closest("tr");
					var clinic = tr.data("clinic");
					tr.addClass("warning");
					$.ajax({
						"dataType": "JSON",
						"method": "POST",
						"url": "/worklist/specialty-hospital/one-click-referrals-reviewed/distribute",
						"data": {
							"clinic": clinic,
							"action": "removeDistro",
							"case": $("#ocrcId").val()
						},
						"success": function (data) {
							tr.removeClass("warning").remove();
						}
					});
					el.closest("tr").remove();
				});

			},

			/*
			 * Vetology.OneClickReferral._auhtorizePatientTransfer
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_auhtorizePatientTransfer: function(token, transfer){
				var o = this;
				$("body").Vetology("doRequest",
					'POST',
					{
						'auth'		: 1,
						'token'		: token,
						'transfer'	: transfer ? 1 : 0,
					},
					window.location.pathname,
					function(json){
						switch(json.status){
							case 0:
								$('body').Vetology(
									'do',
									[
										'showDialog',
										'Error:',
										json.reason
									]
								);
							break;
							case 1:
								if(transfer){
									$(".status_succ").removeClass('hide');
								} else {
									$(".status_fail").removeClass('hide');
								}
								$(".transfer_trigger").remove();
							break;
							case 3:
								if(transfer){
									$(".status_succ").removeClass('hide');
								} else {
									$(".status_fail").removeClass('hide');
								}
								$(".transfer_trigger").remove();
							break;
						}
					},
					'JSON'
				);
			},
			/*
			 * Vetology.OneClickReferral._makeJoinNetRequest
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_makeJoinNetRequest: function(id, alertMessage, alertTitle, d, el){
				$.ajax({
					url: '/clinic-has-email',
					data: {
						id: id
					},
					success: function(data){
						var hasEmail = data.has;
						var clinicEmail = data.clinicEmail;
						var message_box = '<div class="form-group"><label class="control-label" for="dataPullsToggle"><input value="1" checked="checked" class="dataPullsToggle" name="clinicDataPulls" type="checkbox"> Enable clinic\'s OCR data pulls. <a style="color:#2C88BC" href="/doc/one-click-referral-data-sources" target="_blank" class="vetology-faq" title="Click here to learn more"></a></label></div><div class="form-group"><textarea style="max-width: 100%; max-height: 200px; " class="form-control" name="shmessage" placeholder="' + alertMessage + '"></textarea></div>';
						if(hasEmail == false){
							message_box = '<div class="form-group"><label class="col-sm-2 control-label" for="clinicEmail">Clinic email</label><div class="col-sm-10"><input name="clinicEmail" class="form-control " placeholder="Please enter the clinc\'s email" type="text"></div></div><div class="form-group"><label class="control-label" for="clinicnoEmail"><input name="clinicnoEmail" type="checkbox"> I don\'t have the clinic\'s email, please contact them for me.</label></div>' + message_box;
							alertTitle += "<br><br><div class=\"callout callout-warning\"><h4><i class=\"icon fa fa-warning\"></i>&nbsp;Attention</h4>The clinic you have selected has their email address protected, in order to deliver your request please enter their email below";
						}
						$('body').Vetology(
							'do',
							[
								'showPromptDialog',
								alertTitle,
								message_box,
								function(data){
									/*
									0 to join SH
									1 to ask Clinic to join
									*/
									$("body").Vetology("vetologyLoadStart", "Please wait while I send your request", "Please wait while I send your request");
									d.email = !hasEmail ? clinicEmail : '';
									d.dataPulls = data.clinicDataPulls;
									d.message = data.shmessage != '' && typeof data.shmessage != 'undefined' ? data.shmessage : (d.type == 0 ? 'A clinic is asking you to accept them in your OCR network' : 'Please join ' + el.data('shname') + '\'s referral network');;
									$.ajax({
										url: '/joinNetwork',
										data: d,
										success: function(data){
											$("body").Vetology("vetologyLoadEnd");
											if(data.success){
												if(typeof data.make_active !== "undefined"){
													var icon = $("[data-gpid=\"" + el.data('id') + "\"]");
													icon.data("reload", 1);
													icon.data("active", 1);
													icon.data("datapulls", d.dataPulls);
													icon.data("name", data.name);
													icon.data("clinic", data.clinic_id);
//													icon.click();
													$("body").Vetology("vetologyShowDialog", "Success:", data.message, "success");
													$(".joinNetwork2").hide();
												} else {
													$("body").Vetology("vetologyShowDialog", "Success:", "The request has been successfully sent.", "success");
												}
											} else {
												$("body").Vetology("vetologyShowDialog", "Attention:", data.message, "error");
											}
										},
										dataType: 'JSON'
									});
								}
							]
						);
					},
					dataType: 'JSON'
				});
			},
			/*
			 * Vetology.OneClickReferral._makeJoinOcrSH
			 *
			 * @description	Processes a request to join a particular clinic
			 *
			 * @return NULL
			 *
			 */
            _makeJoinOcrSH: function (id, alertMessage, alertTitle, d, el){
            	$.ajax({
                    url: '/clinic-has-email',
                    data: {
                        id: id
                    },
                    success: function(data){
                        var hasEmail = data.has;
                        var message_box = '<div class="form-group"><textarea style="max-width: 100%; max-height: 200px; " class="form-control" name="shmessage" placeholder="' + alertMessage + '"></textarea></div>';
                        if(hasEmail == false){
                            message_box = '<div class="form-group"><label class="col-sm-2 control-label" for="clinicEmail">Specialty hospital email</label><div class="col-sm-10"><input name="clinicEmail" class="form-control " placeholder="Please enter the specialty hospital\'s email" type="text"></div></div><div class="form-group"><label class="control-label" for="clinicnoEmail"><input name="clinicnoEmail" type="checkbox"> I don\'t have the specialty hospital\'s email, please contact them for me.</label></div>' + message_box;
                            alertTitle += "<br><br><div class=\"callout callout-warning\"><h4><i class=\"icon fa fa-warning\"></i>&nbsp;Attention</h4>The clinic you have selected has their email address protected, in order to deliver your request please enter their email below";
                        }
                        $('body').Vetology(
                            'do',
                            [
                                'showPromptDialog',
                                alertTitle,
                                message_box,
                                function(data){
									/*
									 0 to join SH
									 1 to ask Clinic to join
									 */
                                    $("body").Vetology("vetologyLoadStart", "Please wait while I send your request", "Please wait while I send your request");
                                    d.email = !hasEmail ? data.clinicEmail : '';
                                    d.dataPulls = data.clinicDataPulls;
                                    d.message = data.shmessage != '' && typeof data.shmessage != 'undefined' ? data.shmessage : (d.type == 0 ? 'A clinic is asking you to accept them in your OCR network' : 'Please join ' + d.requestingName + '\'s referral network');;
                                    $.ajax({
                                        url: '/joinNetwork',
                                        data: d,
                                        success: function(data){
                                            $("body").Vetology("vetologyLoadEnd");
                                            if(data.success){
                                                if(typeof data.make_active !== "undefined"){
                                                    var icon = $("[data-gpid=\"" + el.data('id') + "\"]");
                                                    icon.data("reload", 1);
                                                    icon.data("active", 1);
                                                    icon.data("datapulls", dataPulls);
                                                    icon.data("name", data.name);
                                                    icon.data("clinic", data.clinic_id);
                                                    icon.click();
                                                    $("body").Vetology("vetologyShowDialog", "Success:", data.message, "success");
                                                } else {
                                                    $("body").Vetology("vetologyShowDialog", "Success:", "The request has been successfully sent.", "success");
                                                }
                                            } else {
                                                $("body").Vetology("vetologyShowDialog", "Attention:", data.message, "error");
                                            }
                                        },
                                        dataType: 'JSON'
                                    });
                                }
                            ]
                        );
                    },
                    dataType: 'JSON'

                });
			},

			/*
			 * Vetology.OneClickReferral._completeNetyworkRequest
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_completeNetyworkRequest: function(el, icon){
				var id = icon.data('id');
				var type = icon.data('type');
				var email = el.data("email");
				var clinic = icon.data('join');
				var message = el.data("message").trim();
				var dataPulls = el.data("dataPulls");
				var alias = el.data('clinic');
				if(message == ''){
					message = 'Please join our network so we can easily distribute you related cases';
				}
				$("body").Vetology("vetologyLoadStart", "Please wait while I send your join request", "Please wait while I send your join request");
				$.ajax({
					url: '/joinNetwork',
					data: {
						id			: id,
						type		: type,
						email		: email,
						clinic		: clinic,
						message		: message,
						dataPulls	: dataPulls,
						alias		: alias
					},
					success: function(data){
						icon.replaceWith('<p style="font-size: 20px;font-weight:bold;">To add another clinic choose from the column on the right or click <a href=\"/specialty-hospital/manage/clinic-sign-up\">here</a> to go back to your clinic sign-up page</a>');//
						$("body").Vetology("vetologyLoadEnd");
						if(data.success){
							$("body").Vetology("vetologyShowDialog", "Success:", "The request has been successfully sent.", "success");
						} else {
							$("body").Vetology("vetologyShowDialog", "Attention:", data.message, "error");
						}
						if(typeof data.remove_alias != "undefined"){
							$(".clinic_pms_adder").each(function(i, el){
								el = $(el);
								if(el.data("clinic") == data.remove_alias){
									el.remove();
								}
							});
						}
					},
					error: function(data){
						$("body").Vetology("vetologyLoadEnd");
						$("body").Vetology("vetologyShowDialog", "Warning:", "Something unexpected happened, we could not make the request", "error");
					},
					dataType: 'JSON'
				});
			},
			/*
			 * Vetology.OneClickReferral._setStatusKeyword
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_updateClinicNetwork: function(config, callback){
				$("body").Vetology("vetologyLoadStart", "Please wait while I make the data-pull request for you", "Please wait while I make the data-pull request for you");
				$.ajax({
					url: '/specialty-hospital/manage/network/set',
					data: config,
                    type: 'post',
					error: function(e){
						$("body").Vetology("vetologyLoadEnd");
						$("body").Vetology("vetologyShowDialog", "Warning:", "Something unexpected happened, we could not make the request", "error");
					},
					success: function(data){
						$("body").Vetology("vetologyLoadEnd");
						if(data.success){
							if(config.all == 1){
								$("body").Vetology("vetologyShowDialog", "Success:", data.message, "success");
							}
							if(typeof callback == "function"){
								callback();
							}
							
						} else {
							$("body").Vetology("vetologyShowDialog", "Warning:", data.message, "error");
						}
					},
					dataType: 'JSON'
				});
			},
			/*
			 * Vetology.OneClickReferral._setStatusKeyword
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_getAnalytics: function(el){
				$("body").Vetology("vetologyLoadStart", "Please wait while I get your analytics", "Please wait while I get your analytics");
				$.ajax({
					url: '/specialty-hospital/manage/analytics',
					data: {
						trendType	: $('.trendType').val(),
						fromDate	: $('.fromDate').val(),
						toDate		: $('.toDate').val(),
						hospital	: $('.trendHospital').val()
					},
					error: function(e){
						$("body").Vetology("vetologyLoadEnd");
						$("body").Vetology("vetologyShowDialog", "Warning:", "Something unexpected happened, we could not gather the analytics", "error");
						console.log(e);
					},
					success: function(r){
						$("body").Vetology("vetologyLoadEnd");
						$(".geoMap").data("lat", r.sh.latitude).data("lng", r.sh.longitude).data("title", r.sh.ClinicName);
						window.analytics_data = r;
						$('body').Vetology('do', ['redrawAnalytics']);
					},
					dataType: 'JSON'
				});
			},
			/*
			 * Vetology.OneClickReferral._setStatusKeyword
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_setStatusKeyword: function(el){
				var p = el.closest("th").find("input");
				var id = p.data("specialty");
				var setting = p.attr("name");
				var value = p.val();
				$("body").Vetology("vetologyLoadStart", "Please wait while the keyword is saved", "Please wait while the keyword is saved");
				$.ajax(
					{
						url		: '/specialty-hospital/manage/change-setting',
						method	: 'POST',
						data	: {
							id: id,
							setting: setting,
							value: value
						},
						success: function(){
							$("body").Vetology("vetologyLoadEnd");
							$("body").Vetology("vetologyShowDialog", "Success:", "The keyword has been saved", "success");
						},
						error: function(e){
							$("body").Vetology("vetologyLoadEnd");
							$("body").Vetology("vetologyShowDialog", "Warning:", "Something unexpected happened, settings could not be saved", "error");
							console.log(e);
						},
					}
				);
			},
			/*
			 * Vetology.OneClickReferral.updateClinicNetwork
			 *
			 * @description	Initializes the loaded elements according to the needs
			 *
			 * @return NULL
			 *
			 */
			_initObject: function(){
				if(typeof window.referralOptions == 'object'){
					var o = this;
					var container = $(".clinic_network");
					o.options.config = jQuery.extend(true, {}, window.referralOptions);
					delete window.referralOptions;
					var html = $(o.options.config.clinics);
					if(!$(".table_ocr_clinic_list_notifications").hasClass('dataTable')){
						o.options.config.vetologyDataTable_notifications = $(".table_ocr_clinic_list_notifications").DataTable({
							"aoColumnDefs" : [{
								"bSortable" : false,
								"aTargets" : ["no-sort"]
							}]
						});
					}
					if(!$(".table_ocr_clinic_list_distro_2").hasClass('dataTable')){
						o.options.config.vetologyDataTable_distro_2 = $(".table_ocr_clinic_list_distro_2").DataTable({
							"aoColumnDefs" : [{
								"bSortable" : false,
								"aTargets" : ["no-sort"]
							}]
						});
					}
					if(!$(".table_ocr_clinic_list_distro").hasClass('dataTable')){
						o.options.config.vetologyDataTable_distro = $(".table_ocr_clinic_list_distro").DataTable({
							"aoColumnDefs" : [{
								"bSortable" : false,
								"aTargets" : ["no-sort"]
							}]
						});
						o.options.config.timeZones = o.options.config.zones;
						o.options.config.defaultTimeZone = o.options.config.sh_tz;
					}
				}
			},
			_getTimeSelectorHTML: function(config, all_items){
				var o = this;
				var html = "<div class=\"distro_crontoller\">";
				if (config.auto_distro_type == 0) {
					html = o.getTimeSelectorTimeDelay(config, html);
				} else {
					html = o.getTimeSelectorTimeZone(config, html);
				}
				html += "<div><a class=\"" + (typeof all_items != "undefined" ? "all_items" : "") + " btn btn-flat btn-primary saveDateTimeDelay\">Save changes</a></div>";
				html += "</div>";
				return html;
			},
			getTimeSelectorTimeDelay: function (config, html) {
				const o = this;
				html += "<div>";
				html += "<div class=\"form-group\">";
				html += "<div class=\"input-group\">";
				html += "<select class=\"form-control pull-right auto_distro_type\" data-placeholder=\"Select a type of delay for this clinic\">";
				html += "<option value=\"0\" selected=\"selected\">Deliver after a time delay of</option>";
				html += "<option value=\"1\">Deliver at a specific time during the day</option>";
				html += "</select>";
				html += "</div>";
				html += "</div>";
				html += "</div>";
				if (config.auto_distro_delay_type == 2) {
					var timer = 31;
					config.auto_distro_delay = config.auto_distro_delay > 30 || config.auto_distro_delay < 0 ? 0 : config.auto_distro_delay;
				} else if (config.auto_distro_delay_type == 1) {
					var timer = 24;
					config.auto_distro_delay = config.auto_distro_delay > 23 || config.auto_distro_delay < 0 ? 0 : config.auto_distro_delay;
				} else {
					config.auto_distro_delay_type = 0;
					var timer = 60;
					config.auto_distro_delay = config.auto_distro_delay > 59 || config.auto_distro_delay < 0 ? 0 : config.auto_distro_delay;
				}
				var timer = config.auto_distro_delay_type == 2 ? 31 : (config.auto_distro_delay_type == 1 ? 24 : 60);
				html += "<div>";
				html += "<div class=\"form-group\">";
				html += "<div class=\"input-group\">";
				html += "<select style=\"width:60px;\" class=\"form-control pull-left auto_distro_delay\" data-placeholder=\"Select a type of delay for this clinic\">";
				for (var i = 0; i < timer; i++) {
					html += "<option value=\"" + i + "\" " + (i == config.auto_distro_delay ? " selected=\"selected\"" : "") + ">" + i + "</option>";
				}
				html += "</select>";
				html += "<select style=\"width:100px;\" class=\"form-control pull-right auto_distro_delay_type\" data-placeholder=\"Select a type of delay for this clinic\">";
				html += "<option value=\"0\" " + (0 == config.auto_distro_delay_type ? " selected=\"selected\"" : "") + ">Minute(s)</option>";
				html += "<option value=\"1\" " + (1 == config.auto_distro_delay_type ? " selected=\"selected\"" : "") + ">Hour(s)</option>";
				html += "<option value=\"2\" " + (2 == config.auto_distro_delay_type ? " selected=\"selected\"" : "") + ">Day(s)</option>";
				html += "</select>";
				html += "</div>";
				html += "</div>";
				html += "</div>";
				return html;
			},
			getTimeSelectorTimeZone: function (config, html) {
				const o = this;
				var timezone = o._getTimeZoneHTML(config.auto_distro_time_zone);
				html += "<div>";
				html += "<div class=\"form-group\">";
				html += "<div class=\"input-group\">";
				html += "<select class=\"form-control pull-right auto_distro_type\" data-placeholder=\"Select a type of delay for this clinic\">";
				html += "<option value=\"0\">Deliver after a time delay of</option>";
				html += "<option value=\"1\" selected=\"selected\">Deliver at a specific time during the day</option>";
				html += "</select>";
				html += "</div>";
				html += "</div>";
				html += "</div>";
				html += "<div>";

				html += "<div>";
				html += "<div class=\"form-group\">";
				html += "<div class=\"input-group\">";
				html += "<select style=\"width: 65px;\" class=\"form-control pull-left auto_distro_hour\" data-placeholder=\"Select a type of delay for this clinic\">";
				for (let i = 0; i < 24; i++) {
					var value = i < 10 ? "0" + i : i;
					html += "<option value=\"" + value + "\" " + (i == config.auto_distro_delay ? " selected=\"selected\"" : "") + ">" + value + "</option>";
				}
				html += "</select><span class=\"pull-left\" style=\"line-height: 30px;font-size: 30px\">:</span>";
				html += "<select style=\"width: 65px;\" class=\"form-control pull-right auto_distro_minute\" data-placeholder=\"Select a type of delay for this clinic\">";
				for (i = 0; i < 60; i++) {
					var value = i < 10 ? "0" + i : i;
					html += "<option value=\"" + value + "\" " + (i == config.auto_distro_delay ? " selected=\"selected\"" : "") + ">" + value + "</option>";
				}
				html += "</select>";
				html += "</div>";
				html += "</div>";
				html += "</div>";
				html += "<div>";
				html += timezone;
				return html;
			},

			_getTimeZoneHTML: function(zone){
				var o = this;
				zone = typeof zone == "undefined" || zone == null || zone == '' ? o.options.config.defaultTimeZone : zone;
				var html = "<select class=\"form-control  time_zone_selector\" data-placeholder=\"Type or scroll to search\">";
				$.each(o.options.config.zones, function(i, zone_group){
					html += "<optgroup label=\"" + zone_group.name + "\">";
					$.each(zone_group.options, function(key, name){
						html += "<option value=\"" + key + "\" " + (zone == key ? "selected=\"selected\"" : "") + ">";
						html += name;
						html += "</option>";
					});
					html += "</optgroup>";
				});
				html += "</select>";
				return html;
			}
		}
	);
})(jQuery);
